import axios from 'axios';

// Função para determinar a URL base da API com base no ambiente
const getApiBaseUrl = () => {
  // Se estiver definido no .env, use essa configuração
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Obter o domínio atual
  const currentDomain = window.location.hostname;
  const currentPort = window.location.port;
  const protocol = window.location.protocol;

  // Se estiver rodando localmente
  if (currentDomain === 'localhost' || currentDomain === '127.0.0.1') {
    return 'http://localhost:5001';
  }

  // Se estiver rodando em um domínio do Cloudflare ou qualquer outro domínio de produção
  // Assumimos que a API está no mesmo domínio
  return `${protocol}//${currentDomain}${currentPort ? `:${currentPort}` : ''}`;
};

const API_URL = getApiBaseUrl();
console.log('API: URL base configurada como:', API_URL);

// Cria uma instância do axios com configurações padrão
const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json'
  }
});

console.log('API: URL base completa configurada como:', `${API_URL}/api`);

// Interceptor para adicionar o token de autenticação a todas as requisições
api.interceptors.request.use(
  async (config) => {
    console.log(`API Interceptor: Preparando requisição para: ${config.url}`);
    console.log(`API Interceptor: Método: ${config.method?.toUpperCase()}`);
    console.log(`API Interceptor: Parâmetros:`, config.params);
    
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log(`API Interceptor: Token encontrado e adicionado ao header`);
    } else {
      console.log(`API Interceptor: Nenhum token encontrado no localStorage`);
    }
    
    console.log(`API Interceptor: Headers completos:`, config.headers);
    return config;
  },
  (error) => {
    console.error('API Interceptor: Erro no interceptor de requisição:', error);
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de resposta
api.interceptors.response.use(
  (response) => {
    console.log(`API Interceptor: Resposta recebida de: ${response.config.url}`, response.status);
    return response;
  },
  (error) => {
    console.error('API Interceptor: Erro na resposta:', error.response?.status, error.config?.url);
    console.error('API Interceptor: Dados do erro:', JSON.stringify(error.response?.data, null, 2));
    console.error('API Interceptor: Mensagem do erro:', error.message);
    
    // Logar estrutura completa do erro para depuração
    if (error.response?.data) {
      console.error('API Interceptor: Estrutura de erro detalhada:', {
        message: error.response.data.message,
        error: error.response.data.error,
        details: error.response.data.details,
        validation: error.response.data.validation
      });
    }
    
    // Se não houver resposta, pode ser um erro de conexão
    if (!error.response) {
      console.error('API Interceptor: Erro de conexão com o servidor');
      return Promise.reject(new Error('Erro de conexão com o servidor. Verifique se o backend está em execução.'));
    }
    
    // Tratar erros de autenticação (401)
    if (error.response.status === 401) {
      console.log('API Interceptor: Erro de autenticação 401');
      
      // Verificar o código de erro específico retornado pelo backend
      const errorCode = error.response.data?.code;
      
      // Limpar o token de autenticação
      localStorage.removeItem('authToken');
      
      // Redirecionar para a página de login com mensagem apropriada
      const errorMessage = encodeURIComponent(
        errorCode === 'TOKEN_EXPIRED' ? 'Sua sessão expirou. Por favor, faça login novamente.' :
        errorCode === 'INVALID_TOKEN' ? 'Token inválido. Por favor, faça login novamente.' :
        'Você precisa estar autenticado para acessar esta página.'
      );
      
      // Redirecionar para a página de login com a mensagem de erro
      window.location.href = `/login?error=${errorMessage}`;
      
      // Retornar uma promessa rejeitada para interromper o fluxo
      return Promise.reject(error);
    }
    
    // Tratar erros de permissão (403)
    if (error.response.status === 403) {
      console.log('API Interceptor: Erro de permissão 403');
      // Retornar o erro para que o componente possa mostrar uma mensagem apropriada
      return Promise.reject({
        ...error,
        isPermissionError: true,
        message: error.response.data?.message || 'Você não tem permissão para acessar este recurso.'
      });
    }
    
    // Para outros erros, apenas rejeitar a promessa
    return Promise.reject(error);
  }
);

export default api;
